export const USER_REJECTED_REQUEST_ERROR = {
  message: "The user rejected the request.",
  code: 4001,
}
